import { render, staticRenderFns } from "./StudentFeedBack.vue?vue&type=template&id=2307ea56&"
import script from "./StudentFeedBack.vue?vue&type=script&lang=js&"
export * from "./StudentFeedBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports